/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Use_3_ValueInputs */

const en_svc_research_use_3_value = /** @type {(inputs: Svc_Research_Use_3_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Competitors, tenders or regulations are checked on a schedule, and changes are summarised.`)
};

const lv_svc_research_use_3_value = /** @type {(inputs: Svc_Research_Use_3_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konkurenti, iepirkumi vai regulējums tiek pārbaudīti regulāri, un izmaiņas apkopotas.`)
};

/**
* | output |
* | --- |
* | "Competitors, tenders or regulations are checked on a schedule, and changes are summarised." |
*
* @param {Svc_Research_Use_3_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_use_3_value = /** @type {((inputs?: Svc_Research_Use_3_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Use_3_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_use_3_value(inputs)
	return en_svc_research_use_3_value(inputs)
});